import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiAccordion = {
  defaultProps: {
    defaultExpanded: false,
    disableGutters: true,
    elevation: 0,
    square: true
  },
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
      marginLeft: capitalDesignTokens.foundations.units.unitHalf,
      marginRight: capitalDesignTokens.foundations.units.unitHalf,
      "&:before": {
        display: "none"
      }
    })
  },
  variants: [
    {
      props: { variant: "selected" },
      style: ({ theme }) => ({
        borderLeft: `4px solid ${theme.palette.primary.main}`
      })
    },
    {
      props: { variant: "arrowAlignmentRight" },
      style: {
        ".MuiAccordionSummary-root": {
          flexDirection: "row"
        },
        ".MuiAccordionSummary-content": {
          justifyContent: "flex-start",
          gap: capitalDesignTokens.foundations.units.unit1
        }
      }
    }
  ]
};
const MuiAccordionSummary = {
  styleOverrides: {
    root: ({ theme }) => ({
      border: `1px solid transparent`,
      paddingLeft: capitalDesignTokens.foundations.units.unit1,
      paddingRight: capitalDesignTokens.foundations.units.unit2,
      flexDirection: "row-reverse",
      minHeight: capitalDesignTokens.foundations.units.unit8,
      "&:hover": {
        backgroundColor: theme.palette.action.hover
      },
      "&:focus": {
        backgroundColor: theme.palette.action.hover,
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: "-2px"
      },
      // Ensures the MuiAccordionSummary expand icon rotates correctly when the arrowAlignmentRight variant is used.
      // When the arrowAlignmentRight variant is used, the expand icon should be rotated per MUI's default behavior.
      // Otherwise the expand icon should be rotated per the Capital Design System's default behavior (see below).
      "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded:not(.MuiPaper-arrowAlignmentRight .MuiAccordionSummary-expandIconWrapper.Mui-expanded)": {
        transform: "rotate(90deg)"
      }
    }),
    content: ({ theme }) => ({
      marginLeft: theme.spacing(1),
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between"
    })
  }
};
const MuiAccordionDetails = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2),
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between"
    })
  }
};
export {
  MuiAccordion,
  MuiAccordionDetails,
  MuiAccordionSummary
};
//# sourceMappingURL=MuiAccordion.js.map
